import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppState } from 'redux/config/store'
import { finchActions } from '../finchSlice'
import { PayrollProvider } from '../finchTypes'
import { GenericSelectModal } from 'shared/components/GenericSelectModal'

// Original SelectProvidersModal for backward compatibility
interface SelectProvidersModalProps {
  open: boolean
  onClose: (e: React.MouseEvent<any>) => void
  selectProvider: (provider: PayrollProvider) => void
}

const SelectProvidersModal = React.memo((props: SelectProvidersModalProps) => {
  const { open, onClose, selectProvider } = props
  const { payrollProviders, loading, error } = useSelector(
    (state: AppState) => state.finchProviders
  )

  const dispatch = useDispatch()

  useEffect(() => {
    if (!payrollProviders.length) {
      dispatch(finchActions.fetchRequest())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <GenericSelectModal<PayrollProvider>
      open={open}
      onClose={onClose}
      onSelect={selectProvider}
      items={payrollProviders}
      getDisplayName={(provider) => provider.displayName}
      getIcon={(provider) => provider.icon}
      title='Select a Provider'
      searchPlaceholder='Search for a provider...'
      loading={loading}
      error={error}
    />
  )
})

// Helps to identify component in React error logs
if (process.env.NODE_ENV !== 'production') {
  SelectProvidersModal.displayName = 'SelectProvidersModal'
}

export default SelectProvidersModal
